import { animate, style, transition, trigger } from '@angular/animations';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { defineLocale, formatDate, ptBrLocale } from 'ngx-bootstrap/chronos';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { MaskService } from 'src/app/shared/services/mask.service';
import { StorageService } from 'src/app/shared/services/storage.service';
import { environment } from 'src/environments/environment';
import { ProjetoCadastro } from '../../../models/projeto-cadastro.model';
import { ProjetoCadastroService } from '../../../services/projeto-cadastro.service';

defineLocale('pt-br', ptBrLocale);

@Component({
  selector: 'app-projeto-list',
  templateUrl: './projeto-list.component.html',
  styleUrls: ['./projeto-list.component.scss'],
  animations: [
    trigger('slideIn', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateX(-50%)' }),
        animate('500ms ease-out', style({ opacity: 1, transform: 'translateX(0)' }))
      ]),
      transition(':leave', [
        animate('300ms ease-in', style({ opacity: 0, transform: 'translateX(-50%)' }))
      ])
    ])
  ],
})
export class ProjetoListComponent extends BaseListComponent<ProjetoCadastro> implements OnInit {

  form: FormGroup;
  filters: any;
  projetoList: ProjetoCadastro[];
  total: any;
  filterActive: boolean = false;
  processFilters: any;
  modalPrintRef?: BsModalRef;
  report_type: number = 1;
  report_type_1: any;
  reportList: any = [
    { id: 1, label: 'Agrupado por questão' },
    { id: 2, label: 'Relatório/Impressão Lista dos Pré-projetos' },
    { id: 3, label: 'Agrupado por questão de valor unico' },
    { id: 4, label: 'Relatório Simples' },
  ];

  @ViewChild('modalPrint') modalPrint: TemplateRef<any>;

  constructor(
    private router: Router,
    public activatedRoute: ActivatedRoute,
    public projetoCadastroService: ProjetoCadastroService,
    public maskService: MaskService,
    private storageService: StorageService,
    private modalService: BsModalService,
    private localeService: BsLocaleService,
  ) {
    super();
    this.localeService.use('pt-br');
  }

  ngOnInit() {
    this.filters = this.activatedRoute.snapshot.data["filters"];
    this.processFilters = this.filters?.processFilters;
    this.initForm();
    this.search();
  }

  initForm() {
    this.form = new FormGroup({
      filter_agency: new FormControl(null),
      filter_process_sub_stat_id: new FormControl(null),
      filter_process_stat_id: new FormControl(null),
      filter_process_control_id: new FormControl(null),
      filter_project_main_user_cpf: new FormControl(null),
      filter_project_user_cpf: new FormControl(null),
      filter_process_anlyst: new FormControl(null),
      filter_process_user_cpfs: new FormControl(null),
      filter_rf_ben: new FormControl(null),
      filter_rf_exec: new FormControl(null),
      filter_corede_ben: new FormControl(null),
      filter_corede_exec: new FormControl(null),
      filter_city_ben: new FormControl(null),
      filter_city_exec: new FormControl(null),
      filter_project_selected: new FormControl(null),
      filter_cost_total: new FormControl(null),
      filter_cost_total1: new FormControl(null),
      filter_cost_total2: new FormControl(null),
      filter_cost_without_loan: new FormControl(null),
      filter_cost_without_loan1: new FormControl(null),
      filter_cost_without_loan2: new FormControl(null),
      filter_cost_loan: new FormControl(null),
      filter_process_id: new FormControl(null),
      filter_resource_id: new FormControl(null),
      filter_question: new FormArray([]),
    })
    let filterValue = this.storageService.getFilterValue('filterPreProjetoValue');
    if (filterValue) {
      this.filterActive = true;
      this.form.patchValue(filterValue);
      this.getFormArray().push(this.createFormGroup(filterValue?.filter_question?.[0]));
    }
  }

  createFormGroup(value = null): FormGroup {
    const formGroup = {};
    if (this.processFilters?.length) {
      this.processFilters.forEach(field => {
        if (field?.type_id == this.filters?.ppQuestion['TYPE_NUMERICO']) {
          formGroup[field.id] = new FormGroup({
            vl0: new FormControl(value?.[field.id]?.vl0),
            vl1: new FormControl(value?.[field.id]?.vl1),
            vl2: new FormControl(value?.[field.id]?.vl2),
          });
        }
        else if (field?.type_id == this.filters?.ppQuestion['TYPE_DATA']) {
          const setDateRange = (startDate, endDate) => {
            const regex = /^(\d{2})\/(\d{2})\/(\d{4})$/;
            const startMatch = startDate?.match(regex);
            const endMatch = endDate?.match(regex);
            if (startMatch && endMatch) {
              return [
                new Date(startMatch[3], startMatch[2] - 1, startMatch[1]),
                new Date(endMatch[3], endMatch[2] - 1, endMatch[1])
              ]
            }
          };
          let dataRange = value?.[field.id]?.vl1 && value?.[field.id]?.vl2 ? setDateRange(value?.[field.id]?.vl1, value?.[field.id]?.vl2) : null;
          formGroup[field.id] = new FormGroup({
            vl0: new FormControl(value?.[field.id]?.vl0),
            vl1: new FormControl(value?.[field.id]?.vl1),
            vl2: new FormControl(value?.[field.id]?.vl2),
            dataRange: new FormControl(dataRange),
          });
        }
        else {
          formGroup[field.id] = new FormControl(value?.[field.id]);
        }
      });
    }
    return new FormGroup(formGroup);
  }

  getFormArray(): FormArray {
    return this.form.get('filter_question') as FormArray;
  }

  getControl(form: string, controlName: string) {
    const formGroup = this.getFormArray().at(0)?.['controls']?.[form] as FormGroup;
    return formGroup?.get(controlName);
  }

  cleanSearch() {
    this.processFilters = null;
    this.storageService.removeFilterValue('filterPreProjetoValue');
    this.form.reset();
  }

  closeFilter() {
    if (this.filterActive) {
      this.filterActive = false;
    }
  }

  getDataCreate(filterSave = false) {
    let data: any;
    data = Object.assign({}, data, this.form.value);
    if (this.processFilters?.length) {
      this.processFilters.forEach(field => {
        if (field?.type_id == this.filters?.ppQuestion['TYPE_DATA']) {
          const typeRange = this.getControl(field?.id, 'vl0')?.value == 4;
          const formatoDataRegex = /^\d{2}\/\d{2}\/\d{4}$/;
          if (typeRange) {
            const dataRange = this.getControl(field?.id, 'dataRange')?.value;
            if (dataRange?.[0] && !formatoDataRegex.test(dataRange?.[0])) {
              data.filter_question[0][field?.id].vl1 = formatDate(dataRange[0], 'DD/MM/YYYY');
            }
            if (dataRange?.[1] && !formatoDataRegex.test(dataRange?.[1])) {
              data.filter_question[0][field?.id].vl2 = formatDate(dataRange[1], 'DD/MM/YYYY');
            }
          } else {
            const dataSimples = this.getControl(field?.id, 'vl1')?.value;
            if (dataSimples && !formatoDataRegex.test(dataSimples)) {
              data.filter_question[0][field?.id].vl1 = formatDate(dataSimples, 'DD/MM/YYYY');
            }
          }
        }
      })
    }
    if (filterSave && !Object.values(data).every(value => value === null)) {
      this.storageService.setFilterValue('filterPreProjetoValue', data);
    }
    data.filter_question = data.filter_question[0] ?? '';
    return data;
  }

  search(filterSave = false) {
    this.loading();
    this.addSub(
      this.projetoCadastroService.getListSearch(this.getDataCreate(filterSave)).subscribe({
        next: (res) => {
          this.projetoList = res['list'];
          this.total = res['total'];
          this.loaded();
        },
        error: (erro) => {
          this.msgError(erro?.message);
          this.loaded();
        },
      })
    );
  }

  changeProcess() {
    this.getFormArray().clear();
    const id = this.form.get('filter_process_id')?.value;
    if (id) {
      this.loading();
      this.addSub(
        this.projetoCadastroService.getProcessFilters(id).subscribe({
          next: (res) => {
            this.processFilters = res;
            this.getFormArray().push(this.createFormGroup());
            this.loaded();
          },
          error: (erro) => {
            this.msgError(erro?.message);
            this.loaded();
          },
        })
      );
    }
  }

  formatarMedidaFisica(field: string) {
    let value = this.maskService.formatarMedidaFisica(this.form.get(field)?.value, 2);
    this.form.get(field).setValue(value);
  }

  formatarMedidaFisica2(form, field: string, decimal = 2) {
    let value = this.maskService.formatarMedidaFisica(this.getControl(form, field)?.value, decimal);
    this.getControl(form, field)?.setValue(value);
  }

  clearInput(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;
    input.value = '';
  }

  formatDate(form, field: string, typeRange = false) {
    const data = this.getControl(form, field)?.value;
    if (data || data?.length) {
      let formatoDataRegex = /^\d{2}\/\d{2}\/\d{4}$/;
      if (typeRange) {
        if (data?.[0] && !formatoDataRegex.test(data?.[0])) {
          this.getControl(form, 'vl1')?.setValue(formatDate(data[0], 'DD/MM/YYYY'));
        }
        if (data?.[1] && !formatoDataRegex.test(data?.[1])) {
          this.getControl(form, 'vl2')?.setValue(formatDate(data[1], 'DD/MM/YYYY'));
        }
      } else {
        this.getControl(form, field)?.setValue(formatDate(data, 'DD/MM/YYYY'));
      }
    }
  }

  closePrintModal() {
    this.modalPrintRef?.hide();
  }

  openPrintModal() {
    this.modalPrintRef = this.modalService.show(this.modalPrint);
  }

  toQueryString(params: any, prefix: string = ''): string {
    return Object.keys(params)
      .filter(key => params[key] !== null && !(Array.isArray(params[key]) && params[key].length === 0))
      .map(key => {
        const value = params[key];
        const prefixedKey = prefix ? `${prefix}[${encodeURIComponent(key)}]` : encodeURIComponent(key);
        if (Array.isArray(value)) {
          return value.map(val => `${prefixedKey}[]=${encodeURIComponent(val)}`).join('&');
        } else if (typeof value === 'object') {
          return this.toQueryString(value, prefixedKey);
        }
        return `${prefixedKey}=${encodeURIComponent(value)}`;
      })
      .join('&');
  }

  imprimir() {
    const url = environment.clientUrl + '/pre-projeto/projeto/relatorio?report_type=' + this.report_type + '&report_1_param_1=' + this.report_type_1 + '&report_3_param_1=' + this.report_type_1 + '&' + this.toQueryString(this.getDataCreate(false));
    window.open(url, '_blank', 'noopener,noreferrer');
  }
}
